import isNil from 'lodash-es/isNil'

import { AppointmentsScopeParam } from '../../../Appointment'

export function getEmailProfileAppointmentsParams({ isAvailable, threadUuid }) {
  return isAvailable && !isNil(threadUuid)
    ? { [AppointmentsScopeParam.emailThread]: threadUuid }
    : null
}
